import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextField,_vm._g(_vm._b({attrs:{"type":_vm.passwordVisible ? 'text' : 'password',"append-icon":_vm.passwordVisible ? 'visibility' : 'visibility_off',"label":_vm.$t('password'),"rules":_vm.rules},on:{"click:append":function($event){_vm.passwordVisible = !_vm.passwordVisible}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'v-text-field',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }